/**
 * «📋 Контроль сроков» — `div.deadline-bar#deadlineBar` (ui-blocks.md §5.4).
 *
 * Три доли одной полосы: в норме → горит → просрочено. Проценты бэкенд
 * не округляет — ширина сегментов ставится инлайном как есть.
 * Полоса не кликабельна.
 */

import type { DeadlinesBlock } from './types';

interface Props {
    deadlines: DeadlinesBlock;
}

export function DeadlineControl({ deadlines }: Props) {
    const { ok, soon, late, ok_pct, soon_pct, late_pct } = deadlines;

    return (
        <div className="deadline-bar" id="deadlineBar">
            <span className="bar-label">📋 Контроль сроков</span>
            <div className="bar-track" id="deadlineTrack">
                <div className="seg-ok" style={{ width: `${ok_pct}%` }} />
                <div className="seg-soon" style={{ width: `${soon_pct}%` }} />
                <div className="seg-late" style={{ width: `${late_pct}%` }} />
            </div>
            <span className="bar-stats" id="deadlineStats">
                {late > 0 ? (
                    <span className="red">{late} просрочено</span>
                ) : (
                    <span className="green">0 просрочено</span>
                )}
                {' · '}
                {soon > 0 ? (
                    <span className="orange">{soon} горит (≤ 3 дн)</span>
                ) : (
                    '0 горит (≤ 3 дн)'
                )}
                {' · '}
                {ok} в норме
            </span>
        </div>
    );
}
